import { notify } from '@billy/design-system'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { queryClient } from '../../../../../config/queryClient'
import { NotificationKeys } from '../../../../../enums/notificationKeys'
import { QueryKeys } from '../../../../../enums/queryKeys'
import { ORGANIZATION_LOGO_AND_ICON_MAX_SIZE } from '../constants/organizationLogoAndIconMaxSize'
import { uploadOrganizationIcon } from '../query-api'

export const useUploadOrganizationIcon = () => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()

  const { mutate: upload, ...rest } = useMutation(
    (file: File) => {
      return uploadOrganizationIcon(file, organization?.id || '', {
        'x-image-max-height': ORGANIZATION_LOGO_AND_ICON_MAX_SIZE,
        'x-image-max-width': ORGANIZATION_LOGO_AND_ICON_MAX_SIZE,
      })
    },
    {
      onSuccess: () => {
        notify({
          id: NotificationKeys.OrganizationIconUpload,
          message: t('settings.organization.organization_info.icon.upload.success'),
          variant: 'success',
        })
        queryClient.invalidateQueries(QueryKeys.UserOrganization)
      },
      onError: () => {
        notify({
          id: NotificationKeys.OrganizationIconUpload,
          message: t('settings.organization.organization_info.icon.upload.error'),
          variant: 'error',
        })
      },
    },
  )

  return { upload, ...rest }
}
